export default {
  name: '(P) Swatches',
  slug: 'p-swatches',
  class: 'gf_swatch',
  wrap: 'gf_swatches',
};
